import { programsListActions } from './ProgramsListActions';

const initState = {
    showSpinner: {},
    programsList: [],
    error: null,
}

export default function programsListPageReducer(state=initState, action) {
    switch (action.type) {
        case programsListActions.setProgramsList:
            return setProgramsList(state, action);
        case programsListActions.setError:
            return setError(state, action); 
        case programsListActions.toggleSpinner:
            return toggleSpinner(state, action);
        default:
            return state;
    }
}

function setProgramsList(state, {payload}) {
    return {
        ...state,
        programsList: payload,
    }
}

function setError(state, {payload}) {
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        showSpinner: {
            ...state.showSpinner,
            [meta]: payload
        },
    }
}